// Documents & Contracts Tour
// Templates, e-signature, status tracking and signature automations
// Selector policy: step 1 pins to the live-verified sidebar id (#sb_payments); teaching steps are
// deliberate centered cards — no guessed element selectors.

export const documentsTour = {
  id: 'documents',
  name: 'Documents & Contracts Tour',
  displayName: 'Get Agreements Signed',
  description: 'Templates, e-signature, status tracking and signature automations',
  estimatedDuration: '4 minutes',
  category: 'feature',
  autoStart: false,
  prerequisiteTours: ['ftux'],

  config: { animate: true, overlayOpacity: 0.75, smoothScroll: true, allowClose: true, showProgress: true },

  steps: [
    {
      element: '#sb_payments',
      popover: {
        title: "📝 Welcome to Documents & Contracts",
        description: `
          Send a proposal or agreement, have it signed electronically, and keep the signed copy on the customer record — without leaving {{brandName}} for a separate tool.
        `,
        side: 'right',
        align: 'center'
      }
    },

    {
      popover: {
        title: "📄 Build a Template",
        description: `
          Create a **template** for each agreement you send repeatedly. Use **merge fields** so names, addresses, and pricing fill themselves in instead of being retyped every time.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "✍️ Send and Sign",
        description: `
          The customer opens the document in a browser — no account needed — and signs in place. You can require multiple signers and add your own countersignature.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "👀 Track the Status",
        description: `
          Every document shows sent, viewed, signed, or completed. **Viewed but not signed** is the useful state: that is exactly who to follow up with.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🤖 Automate the Follow-up",
        description: `
          Signature events can trigger a **workflow**: nudge an unsigned document after two days, or start onboarding and generate the first invoice the moment it completes.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "📎 Where Signed Copies Live",
        description: `
          Completed documents attach to the contact record, so the agreement lives with the relationship rather than in somebody's email.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🎉 Agreements, Handled",
        description: `
          You can now:

✅ Build reusable templates with merge fields
✅ Collect electronic signatures
✅ Track who viewed but has not signed
✅ Automate reminders and onboarding

**Next:** turn your most-sent agreement into a template.
        `,
        side: 'over',
        align: 'center',
        showButtons: ['close'],
        doneBtnText: 'Done →'
      }
    }
  ]
};
